import { render, staticRenderFns } from "./CommissionListComponent.vue?vue&type=template&id=352403a0&scoped=true"
import script from "./CommissionListComponent.vue?vue&type=script&lang=js"
export * from "./CommissionListComponent.vue?vue&type=script&lang=js"
import style0 from "./CommissionListComponent.vue?vue&type=style&index=0&id=352403a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352403a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352403a0')) {
      api.createRecord('352403a0', component.options)
    } else {
      api.reload('352403a0', component.options)
    }
    module.hot.accept("./CommissionListComponent.vue?vue&type=template&id=352403a0&scoped=true", function () {
      api.rerender('352403a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commission/CommissionListComponent.vue"
export default component.exports